import imageUrlBuilder from '@sanity/image-url'
import { sanityConfig } from './sanityClient'
import { SanityClientLike } from '@sanity/image-url/lib/types/types'

export function imageUrlFor(source?: string) {
  const imageBuilder = imageUrlBuilder(sanityConfig as SanityClientLike)
  // always convert image to jpg which can be compressed.
  return source ? imageBuilder.image(source).quality(50).format('webp') : null
}
